import { useInfiniteQuery } from '@tanstack/react-query';

import type { JourneyListsParams } from '@/types';

import { API_CLIENT } from '@/query/routes';
import { getFormattedDateForApi } from '@/utils/helpers/get-formatted-date-for-api';

const useGetInfiniteJourneyList = ({
  date,
  status,
  sort,
  search,
  limit,
  enabled,
}: JourneyListsParams) => {
  return useInfiniteQuery({
    initialPageParam: 0,
    queryKey: ['journeys', 'infinite', date, status, sort, search, limit],
    queryFn: ({ pageParam = 0 }) =>
      API_CLIENT.infiniteJourneyLists({
        date: date && getFormattedDateForApi(date),
        page: pageParam,
        status,
        sort,
        search,
        limit,
      }),
    gcTime: 0,
    staleTime: 0,
    retry: false,
    enabled,
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.length < 50 ? undefined : allPages.length;
    },
  });
};

export default useGetInfiniteJourneyList;
